import { render, staticRenderFns } from "./EmployeeUniforms.vue?vue&type=template&id=53f67842&scoped=true"
import script from "./EmployeeUniforms.vue?vue&type=script&lang=js"
export * from "./EmployeeUniforms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f67842",
  null
  
)

export default component.exports